module.exports = __webpack_public_path__ + "img/kubernetes-svgrepo-com.e573b775.svg";